export enum TransactionType {
  PURCHASE = 'purchase',
  USAGE = 'usage',
  REFUND = 'refund',
  BONUS = 'bonus'
}

export interface CoinTransaction {
  id: string;
  userId: string;
  type: TransactionType;
  amount: number;
  balanceAfter: number;
  relatedSessionId?: string;
  timestamp: string;
}

export interface CoinBalance {
  balance: number;
}

export interface CoinPackage {
  id: string;
  name: string;
  coins: number;
  price: number;
  isPromotional: boolean;
  description?: string;
}

export interface CoinPurchase {
  packageId: string;
  paymentMethodId?: string;
}
